// extracted by mini-css-extract-plugin
module.exports = {"searchFiltersMobile":"SearchPageBLanding_searchFiltersMobile__3_N_1"};